import Base from '@studiometa/js-toolkit';

/**
 * @typedef {Object} SolutionsRef
 * @property {HTMLElement[]} links[]
 * @property {HTMLElement} cursor
 * @property {HTMLElement} mask
 * @property {HTMLElement} links_container
 * @property {HTMLElement} overlay
 */

/**
 * @typedef {Object} SolutionsInterface
 * @property {SolutionsRef} $refs
 * @property {Number} linkIndex
 */

/**
 * Homepage class.
 */
export default class Solutions extends Base {
  /**
   * Class config
   * @type {Object}
   */
  static config = {
    name: 'Solutions',
    refs: ['links[]', 'cursor', 'mask', 'links_container', 'overlay'],
  };

  /**
   * Initialize the component's behavior.
   *
   * @this {Solutions & SolutionsInterface}
   */
  mounted() {}
}
